export const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
] as const;

export const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'] as const;

export function fmtMoney(amount: number | null | undefined): string {
  if (amount == null) return '—';
  if (amount >= 1000) return amount.toLocaleString(undefined, { maximumFractionDigits: 0 });
  return amount.toLocaleString(undefined, { maximumFractionDigits: 2 });
}

/** "2026-07-09T10:45:00Z" → "10:45"; "10:45:00" → "10:45". */
export function fmtTime(t: string | null | undefined): string {
  if (!t) return '';
  const s = String(t);
  const m = s.match(/T(\d{2}:\d{2})/);
  if (m?.[1]) return m[1];
  if (/^\d{2}:\d{2}/.test(s)) return s.slice(0, 5);
  return s;
}

export function fmtStops(stops: number | null | undefined): string {
  if (stops == null) return '';
  if (stops === 0) return 'direct';
  return `${stops} stop${stops > 1 ? 's' : ''}`;
}

/** Human-friendly duration for an ETA: 45000 → "45s", 150000 → "2m 30s", 3720000 → "1h 2m". */
export function fmtDuration(ms: number): string {
  const s = Math.max(0, Math.round(ms / 1000));
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ${s % 60}s`;
  const h = Math.floor(m / 60);
  return `${h}h ${m % 60}m`;
}

/** "2026-07-09T10:45:00Z" → "Thu 9 Jul". Provider times are wall-clock local times stored as UTC, so never shift them. */
export function fmtDay(t: string | null | undefined): string {
  if (!t) return '';
  const m = String(t).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return String(t);
  const d = new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])));
  return d.toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
}

/** Money with its currency: "1,234 LYD". */
export function fmtPrice(amount: number | null | undefined, currency?: string | null): string {
  if (amount == null) return '—';
  return `${fmtMoney(amount)}${currency ? ` ${currency}` : ''}`;
}

/** Local date-time for records (created dates, expiry deadlines). */
export function fmtDateTime(t: string | null | undefined): string {
  if (!t) return '';
  const ms = Date.parse(String(t));
  if (!Number.isFinite(ms)) return String(t);
  return new Date(ms).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
}
